'use client'
import { useSearchParams } from 'next/navigation'
import querystring from 'querystring'

// Functions

export type UseCreateFilterPathFunc = {
  addFilter: (value: string, clearOnChange?: string[]) => string
  removeFilter: (clearOnChange?: string[]) => string
}
export const useCreateFilterPathFunc = (
  basePath: string,
  filterName: string
): UseCreateFilterPathFunc => {
  const searchParams = useSearchParams()
  const queryPart = new URLSearchParams(searchParams ?? []).toString()
  return {
    addFilter: (value, clearOnChange) => {
      const filters = querystring.parse(queryPart)
      if (clearOnChange) {
        clearOnChange.forEach((clearKey) => {
          delete filters[clearKey]
        })
      }
      delete filters.page
      const query = querystring.stringify({
        ...filters,
        [filterName]: value
      })
      return `${basePath}?${query}`
    },
    removeFilter: (clearOnChange) => {
      const filters = querystring.parse(queryPart)
      if (clearOnChange) {
        clearOnChange.forEach((clearKey) => {
          delete filters[clearKey]
        })
      }
      delete filters[filterName]
      delete filters.page
      const query = querystring.stringify(filters)

      return query.length === 0 ? basePath : `${basePath}?${query}`
    }
  }
}
